import { QueryEmulatorStateProps } from './'

export const formJSON = (compressionRemoval: boolean, upscale: boolean, upscaleValue: string, colorEnhancement: boolean, opacity: string) => {
  const operations = []
  
  if (compressionRemoval) {
    operations.push({ "op": "nn/jpegar" })
  }

  if (upscale && upscaleValue === 'x2') {
    operations.push({ "op": "nn/magic2x" })
  } else if (upscale && upscaleValue === 'x4') {
    operations.push({ "op": "nn/magic4x" })
  } else if(upscale && upscaleValue === 'x8') {
    operations.push({ "op": "nn/magic2x" }, { "op": "nn/magic4x" })
  }


  if (colorEnhancement && opacity) {
    operations.push({ "op": "nn/colorenhance", "opacity": opacity })
  } else if (colorEnhancement) {
    operations.push({ "op": "nn/colorenhance" })
  }

  return {
    "source": {
      "http": {
        "url": ["https://news.artnet.com/app/news-upload/2016/03/Vincent_van_Gogh_-_Sunflowers_-_VGM_F458-256x256.jpg"]
        }
      },
    
    "operations": [
      ...operations,
      {
        "op": "img/encode",
        "format": "jpeg", "format_opts": { "quality": 90 }
      }
    ],
    
    "sink": {
        "temp_store": true
      }
    }
}

export const afterImageSelector = (data: any, state: QueryEmulatorStateProps) => {
  const opacityValue = parseInt(state.opacityCopy)

  if (state.colorEnhancementCopy && opacityValue > 90){
    return {
      desktop: data.imageColor100.childImageSharp.fixed,
      tablet: data.imageColor100.childImageSharp.fixed,
      mobile: data.imageColor100Mob.childImageSharp.fixed
    }
  } else if (state.colorEnhancementCopy && opacityValue > 65) {
    return {
      desktop: data.imageColor75.childImageSharp.fixed,
      tablet: data.imageColor75.childImageSharp.fixed,
      mobile: data.imageColor75Mob.childImageSharp.fixed
    }
  } else if (state.colorEnhancementCopy && opacityValue > 36) {
    return {
      desktop: data.imageColor50.childImageSharp.fixed,
      tablet: data.imageColor50.childImageSharp.fixed,
      mobile: data.imageColor50Mob.childImageSharp.fixed
    }
  } else if (state.colorEnhancementCopy && opacityValue > 0 && opacityValue <= 36) {
    return {
      desktop: data.imageColor25.childImageSharp.fixed,
      tablet: data.imageColor25.childImageSharp.fixed,
      mobile: data.imageColor25Mob.childImageSharp.fixed
    }
  } else if (state.upscaleCopy) {
    return {
      desktop: data.imageUpscale4x.childImageSharp.fixed,
      tablet: data.imageUpscale4x.childImageSharp.fixed,
      mobile: data.imageUpscale4xMob.childImageSharp.fixed
    }
  } else if (state.compressionRemovalCopy) {
    return {
      desktop: data.imageCompressionRemoval.childImageSharp.fixed,
      tablet: data.imageCompressionRemoval.childImageSharp.fixed,
      mobile: data.imageCompressionRemovalMob.childImageSharp.fixed
    }
  } else {
    return {
      desktop: data.imageOriginal.childImageSharp.fixed,
      tablet: data.imageOriginal.childImageSharp.fixed,
      mobile: data.imageOriginalMob.childImageSharp.fixed
    }
  }
  
}

export const afterImageSelectorNew = (data: any, state: QueryEmulatorStateProps) => {
  if (state.colorEnhancementCopy){
    return {
      desktop: data.imageColor100.childImageSharp.fixed,
      tablet: data.imageColor100.childImageSharp.fixed,
      mobile: data.imageColor100Mob.childImageSharp.fixed
    }
  } else if (state.upscaleCopy) {
    return {
      desktop: data.imageUpscale4x.childImageSharp.fixed,
      tablet: data.imageUpscale4x.childImageSharp.fixed,
      mobile: data.imageUpscale4xMob.childImageSharp.fixed
    }
  } else if (state.compressionRemovalCopy) {
    return {
      desktop: data.imageCompressionRemoval.childImageSharp.fixed,
      tablet: data.imageCompressionRemoval.childImageSharp.fixed,
      mobile: data.imageCompressionRemovalMob.childImageSharp.fixed
    }
  } else {
    return {
      desktop: data.imageOriginal.childImageSharp.fixed,
      tablet: data.imageOriginal.childImageSharp.fixed,
      mobile: data.imageOriginalMob.childImageSharp.fixed
    }
  }
  
}

export const getLabelAfterText = (state: QueryEmulatorStateProps) => {
  const upscaleValue = parseInt(state.upscaleValue.charAt(1))
  let subtitle
  
  if (upscaleValue && state.upscale) {
    subtitle = `${upscaleValue * state.originalWidth} x ${upscaleValue * state.originalHeight}`
  } else {
    subtitle = state.upscaleWidth ?
    `${state.upscaleWidth} x  ${state.upscaleHeight}`:
    `${state.originalWidth} x  ${state.originalHeight}`
  }

  if (state.colorEnhancement) {
    return {
      title: 'Color enhancement',
      subtitle
    }
  }

  if (state.upscale) {
    return {
      title: 'Upscaled',
      subtitle
    }
  }

  if (state.compressionRemoval) {
    return {
      title: 'Compression Removal',
      subtitle
    }
  }

  return {
    title: 'Original',
    subtitle
  }
}

export const isMobile = () => {
  const largeMobile = 415
  const isMobile = window.innerWidth < largeMobile

  if (typeof window !== 'undefined' && isMobile) {
    return true
  }

  return false
}